"use strict";
export {};
//# sourceMappingURL=IDiagnosticLogger.js.map